import axios from 'axios';
import authHeader from '../auth-header';

import tokenHeader from '../token-header';

import baseUrl from '../base-url';

const API_URL = baseUrl()+"/api/all/";

const getKotaKabupaten = 'kota-kabupaten';

const postKotaKabupatenUrl = 'kota-kabupaten';
const putKotaKabupaten = 'kota-kabupaten/';
const deleteKotaKabupaten = 'kota-kabupaten/';

class KotaKabupatenService {
    getKotaKabupaten(currentPage,pageSize,filter) {
        return axios.get(
            API_URL + getKotaKabupaten + '?pageNo=' + currentPage + '&pageSize='+pageSize+"&filter="+filter,
            {
                headers: authHeader()
            });
    }

    getAll() {
        return axios.get(
            API_URL + getKotaKabupaten + '?pageNo=0&pageSize=1000&filter=default',
            {
                headers: authHeader()
            });
    }

    postKotaKabupaten(formData) {        
        return axios
        .post(
            API_URL + postKotaKabupatenUrl,
            formData,
            { headers: authHeader() }
        );
    }

    putKotaKabupaten(formData) {
        var headers = authHeader(); 
        var data = {
            kode : formData.kode,
            name : formData.name,
            status : formData.status,
            provinceId : formData.province_id
        }
        return axios
        .put(
            API_URL + putKotaKabupaten + formData.id_kota_kab, data,
            { headers: authHeader() }
        );
    }

    deleteKotaKabupaten(idKotaKab) {
        var headers = authHeader();

        return axios
            .delete(
                API_URL + deleteKotaKabupaten + idKotaKab,
                { headers: authHeader() }
            );
    }

}

export default new KotaKabupatenService();